import PhotoPlaceholder from './photo-placeholder';
import { HISTORIAS } from '../data/content';
import { eyebrow } from '../lib/styles';

// Lives on /promociones in the design, not the home page -- future
// integration point for the real Instagram Stories API.
const InstagramStories = () => (
  <div
    style={{
      marginTop: '4vw',
      background: '#FFF',
      border: '1px solid var(--ink-200)',
      borderRadius: 'var(--radius-xl)',
      padding: 30,
    }}
  >
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 12,
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 22,
      }}
    >
      <div>
        <span style={{ ...eyebrow, color: 'var(--lavender-700)' }}>Instagram</span>
        <h2
          style={{
            fontFamily: 'var(--font-display)',
            fontWeight: 400,
            fontSize: 26,
            color: 'var(--ink-900)',
            margin: '8px 0 0',
          }}
        >
          Lo más reciente en historias
        </h2>
      </div>
      <span
        style={{
          fontSize: 11,
          letterSpacing: '.1em',
          textTransform: 'uppercase',
          color: 'var(--caution)',
          background: 'var(--caution-soft)',
          borderRadius: 'var(--radius-pill)',
          padding: '6px 14px',
        }}
      >
        Integración futura · no conectado
      </span>
    </div>
    <div style={{ display: 'flex', gap: 16, overflowX: 'auto', paddingBottom: 8 }}>
      {HISTORIAS.map((h) => (
        <div
          key={h.label}
          style={{ flex: 'none', width: 118, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 9 }}
        >
          <div
            style={{ width: 110, height: 110, borderRadius: '50%', padding: 3, border: '1.5px solid var(--rose-400)' }}
          >
            <PhotoPlaceholder label={h.label} shape="circle" />
          </div>
          <span style={{ fontSize: 11.5, color: 'var(--ink-600)', textAlign: 'center' }}>{h.fecha}</span>
        </div>
      ))}
    </div>
    <p style={{ fontSize: 13.5, lineHeight: 1.6, color: 'var(--ink-500)', margin: '18px 0 0', maxWidth: '70ch' }}>
      Esta franja está diseñada para alimentarse después con la API de Instagram. Hoy muestra contenido de ejemplo y se
      administra manualmente desde el panel.
    </p>
  </div>
);

export default InstagramStories;
